import { Card, type CardProps } from '@mui/material';
import { LoadingOverlay } from './LoadingOverlay';

export const LoadingCard = ({ loading = false, sx, children, ...props }: CardProps & { loading?: boolean }) => (
    <Card elevation={5} sx={{ position: 'relative', display: 'flex', flexDirection: 'column', ...sx }} {...props}>
        {children}

        {loading && <LoadingOverlay />}
    </Card>
);
